import axios from '@axios'

export default {
  namespaced: true,
  state: {
    banner: {
      id: null,
      imagem: '',
      imagem_key: '',
      imagem_mobile: '',
      imagem_mobile_key: '',
      nome_tag: '',
      titulo: '',
      subtitulo: '',
      link: '',
      btn_texto: '',
    },
    banners: [],
  },
  getters: {
    GET_BANNERS: state => state.banners,
  },
  mutations: {
    SET_BANNERS(state, payload) {
      state.banners = payload
    },
    SET_BANNER_CURRENT(state, payload) {
      state.banner = payload
    },
  },
  actions: {
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/banners', { params: queryParams })
          .then(response => {
            ctx.commit('SET_BANNERS', response.data.banners)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    findById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/banners/${id}`)
          .then(response => {
            ctx.commit('SET_BANNER_CURRENT', response.data)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    create(ctx, dataCreate) {
      return new Promise((resolve, reject) => {
        axios
          .post('/banners', dataCreate)
          .then(response => resolve(response))
          .catch(error => {
            reject(error)
          })
      })
    },
    update(ctx, dataUpdate) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/banners/${dataUpdate.id}`, {
            ...dataUpdate,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    delete(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/banners/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
